import React from "react";
import "./UserPopup.scss";
import placeholder from "../../assets/images/subscription/user_window_infected.webp"; // CRYPTO-AWAKE
import counter from "../../assets/images/subscription/counter.webp";
import icon_essence from "../../assets/images/subscription/icon_essence.webp";
import icon_stamina from "../../assets/images/subscription/icon_stamina.webp";
import { Link } from "react-router-dom";
import icon_user_window_visibility from "../../assets/images/subscription/icon_user_window_visibility.webp";
import icon_user_window_setting from "../../assets/images/subscription/icon_user_window_setting.webp";
import icon_user_window_transaction from "../../assets/images/subscription/icon_user_window_transaction.webp";
import icon_user_window_signout from "../../assets/images/subscription/icon_user_window_signout.webp";
import { RiArrowRightSLine } from "react-icons/ri";
import { useAuth } from "../../features/auth/AuthProvider";
import { useCurrency } from "../../hooks/useCurrency";

const formatBalance = (value) =>
  value === null || value === undefined || String(value).trim() === ""
    ? 0
    : value;

const UserPopup = () => {
  const { user, logout } = useAuth();
  const { essence, stamina, supporterPlan } = useCurrency();
  const essenceBalance = formatBalance(essence);
  const staminaBalance = formatBalance(stamina);
  const supporterTier = supporterPlan?.tierName || "";
  const dailyStamina = !supporterTier
    ? ""
    : supporterPlan?.unlimitedStamina
      ? "Unlimited daily stamina"
      : supporterPlan?.dailyStamina
      ? `${supporterPlan.dailyStamina} stamina / day`
      : "";

  const displayName =
    user?.firebaseUser?.displayName || user?.firebaseUser?.email || "User";

  const handleLogout = async () => {
    if (!window.confirm("Are you sure that you want to logout?")) {
      return;
    }

    await logout();
  };

  return (
    <div className="user-popup">
       <Link to="/subscription?tab=buyessence">
        <div className="d-flex">
          <div className="biohazard-icon me-3"> 
            <img src={counter} alt="USER" className="w-1 h-1" />
          </div>
          <div>
            <div className="username">{displayName}</div>
            <div className="tier">Infected - level 5</div>{" "}
            {/* You might fetch this from user profile too */}
          </div>
        </div>
      </Link>
      <div className="image-placeholder">
        <img width={320} src={placeholder} alt="sexy apocalypse" /> 
      </div>
      <div className="upgrade-box">
        <div className="text">
          Subscriber Tiers
          <br />
          <span className={supporterTier ? "valid active" : "valid"}>
            {supporterTier ? supporterTier : "No active plan"}
          </span>
          {dailyStamina && <span className="daily-stamina">{dailyStamina}</span>}
        </div>
        <Link to="/subscription">
          <button className="upgrade-btn">Upgrade Now</button>
        </Link>
      </div>
      <div className="usr-stats">
        <Link to="/subscription?tab=buyessence"> 
          <div className="stats-box">
            <span className="tooltip">Essence never expires and can be used to chat with the Apocalypse Girls, unlock new scenarios and characters, or be exchanged for Apocalypse Lovers products.</span>
            <img width={40} height={40} src={icon_essence} alt="Essence Icon" />
            {/* Display essence from useCurrency hook */}
            <span className="value">{essenceBalance}</span>
            <RiArrowRightSLine className="ms-3 color-gray" />
          </div>
        </Link>
        <Link to="/subscription">
          <div className="stats-box">
             <div className="tooltip">Stamina is consumed before Essence whenever available. It resets daily and can be earned by visiting the site every day or by subscribing to one of the tiers in our support plan.</div>
            <img width={40} height={40} src={icon_stamina} alt="Stamina Icon" />
            {/* Display stamina from useCurrency hook */}
            <span className="value">{staminaBalance}</span>
            <RiArrowRightSLine className="ms-3 color-gray" />
          </div>
        </Link>
      </div>
      <div className="menu-buttons">
        <div className="button-box">
          <img
            width={30}
            height={30}
            src={icon_user_window_visibility}
            alt="Adult"
          />
          <span className="menu-buttons-text">Censor Mode</span>
        </div>
        <Link to="/settings?tab=settings" className="button-box">
          <img
            width={30}
            height={30}
            src={icon_user_window_setting}
            alt="Settings"
          />
          <span className="menu-buttons-text">Settings</span>
        </Link>
        <Link to="/settings?tab=purchase">
          <div className="button-box">
            <img
              width={30}
              height={30}
              src={icon_user_window_transaction}
              alt="Activity"
            />
            <span className="menu-buttons-text">Activity</span>
          </div>
        </Link>
        {/* Use the logout function from AuthContext */}
        <div className="button-box" onClick={handleLogout}>
          <img
            width={30}
            height={30}
            src={icon_user_window_signout}
            alt="Sign Out"
          />
          <span className="menu-buttons-text">Sign Out</span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(UserPopup); // Keep React.memo for performance
